import { cn, getSessionLabel } from '@/lib/utils';

const SESSION_LABEL = getSessionLabel();

function UpcomingLabel() {
  return (
    <div className="text-sm font-medium text-white/40">
      UPCOMING {SESSION_LABEL.uppercase}
    </div>
  );
}

/** Loading skeleton shown inside an UpcomingSessionCardDiv. */
export function SessionCardSkeletonContent({
  isSecondSession,
}: Readonly<{ isSecondSession?: boolean }>) {
  return (
    <>
      {!isSecondSession && <UpcomingLabel />}
      <div className="flex items-center gap-4">
        <div className="bg-white/20 rounded-full h-8 w-16 animate-pulse" />
        <div className="bg-white/20 rounded-full h-8 w-32 animate-pulse" />
      </div>

      <div className="flex items-center gap-8">
        <div className="bg-white/20 rounded-lg h-10 w-40 animate-pulse" />
        <div className="bg-white/20 rounded-lg h-10 w-30 animate-pulse" />
      </div>

      {!isSecondSession && (
        <div className="bg-white/10 rounded-xl p-4">
          <div className="bg-white/20 rounded-full h-8 w-32 animate-pulse" />
        </div>
      )}
    </>
  );
}

/** Neutral empty state shown inside an UpcomingSessionCardDiv. */
export function SessionCardEmptyContent({
  isSecondSession,
}: Readonly<{ isSecondSession?: boolean }>) {
  return (
    <>
      {!isSecondSession && <UpcomingLabel />}
      <div className="flex flex-col items-center justify-center gap-1.5 h-full text-center px-4">
        <p
          className={cn(
            'font-bold text-white/85',
            isSecondSession ? 'text-base' : 'text-xl'
          )}
        >
          {isSecondSession
            ? `More ${SESSION_LABEL.lowercase}s coming up soon`
            : `No upcoming ${SESSION_LABEL.lowercase}s yet`}
        </p>
        <p className="text-sm text-white/50">
          {isSecondSession
            ? `We'll show your next ${SESSION_LABEL.lowercase} here as soon as it's scheduled.`
            : `Your scheduled ${SESSION_LABEL.lowercase}s will show up here once they're ready.`}
        </p>
      </div>
    </>
  );
}
